import { HookActionStatus } from "next-safe-action/hooks";

export const mapStatus = (status: HookActionStatus): "idle" | "executing" => {
  switch (status) {
    case "executing":
      return "executing";
    case "hasSucceeded":
    case "hasErrored":
      return "idle";
    default:
      return "idle";
  }
};